import { HStack, PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import {
  useCreateVolumeScenario,
  volumeScenariosSearchSchema,
} from '@/hooks/queries/crt/useVolumeScenarios'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreateVolumeScenarioDialog } from './-components/CreateVolumeScenarioDialog'
import VolumeScenariosDataTable from './-components/VolumeScenariosDataTable'

export const Route = createFileRoute('/_auth/_modules/crt/volume-scenarios/')({
  component: RouteComponent,
  validateSearch: (search) => volumeScenariosSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateVolumeScenario({
    queries: search,
    handleOnSuccess: (volumeScenarioId) => {
      setIsOpen(false)
      navigate({
        to: '/crt/volume-scenarios/$volumeScenarioId',
        params: { volumeScenarioId: String(volumeScenarioId) },
      })
    },
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('volumeScenarios.pageHeader')}</PageHeader>
        <HStack gap="sm">
          <PermissionsGuard required={['crt_volume_scenarios_create']}>
            <CreateVolumeScenarioDialog
              isOpen={isOpen}
              onOpenChange={setIsOpen}
              isPending={isPending}
              onSubmit={({ name, description, baseCrtPeriod }) =>
                mutate({ name, description, baseCrtPeriod })
              }
            />
          </PermissionsGuard>
        </HStack>
      </Spread>

      <Card>
        <CardContent className="pt-6">
          <VStack gap="md">
            <VolumeScenariosDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
